<template>
  <v-dialog v-model="dialog.show" persistent max-width="900">
    <v-card>
      <v-card-title class="pl-0 pr-0 pt-0 ml-0 mr-0 mt-0">
        <v-toolbar :color="this.getAppBarColor">
          <v-toolbar-title>
            <v-row dense justify="center" align="center">
              <v-col cols="12">
                <span class="align-center">
                  <p class="white--text">{{ dialog.title }}</p>
                </span>
              </v-col>
            </v-row>
          </v-toolbar-title>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-form v-model="form.validate" ref="formCad">
            <v-row dense>
              <v-col cols="12">
                <v-text-field label="Nome" v-model="colaborador.nome" :rules="[rules.required]"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Apelido"
                  v-model="colaborador.apelido"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>

              <v-col cols="12" m="12" md="4">
                <v-autocomplete
                  label="Papel"
                  v-model="colaborador.papel"
                  :rules="[rules.required]"
                  :items="papeis"
                ></v-autocomplete>
              </v-col>
              <!-- <v-col cols="12" m="12" md="4">
                <v-autocomplete
                  label="Função"
                  v-model="colaborador.função"
                  :rules="[rules.required]"
                  :items="papeis"
                ></v-autocomplete>
              </v-col>-->

              <v-col cols="12" m="12" md="4">
                <v-text-field
                  label="Telefone"
                  v-mask="colaborador.telefone && colaborador.telefone.length >= 14 ? '(##)#####-####':'(##)####-####'"
                  v-model="colaborador.telefone"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <SelectEmpresa
                  :multiple="true"
                  :empresasSelecionadas="colaborador.empresas_selecionadas"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="salvar"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="dialog.show = false"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import Colaborador from "@/services/colaborador";

export default {
  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa")
  },
  name: "DialogColaborador",
  data() {
    return {
      dialog: {
        show: false,
        title: "Editar Colaborador"
      },
      id: "",
      colaborador: {
        nome: "",
        apelido: "",
        papel: "",
        telefone: "",
        empresas_selecionadas: []
      },
      papeis: ["Administrador", "Gerente", "Supervisor", "Vendedor"],
      rules: rules,
      form: {
        validate: false
      }
    };
  },
  methods: {
    show(teste = false, item) {
      this.id = "";
      this.dialog.show = teste;
      this.carregar(item);
    },
    carregar(item) {
      this.id = item.id
      this.colaborador.nome = item.nome
      this.colaborador.apelido = item.apelido
      this.colaborador.papel = item.papel
      this.colaborador.telefone = item.telefone
      this.colaborador.empresas_selecionadas.push(...item.empresas)
    },
    async salvar() {
      if (this.$refs.formCad.validate()) {
        try {
          let resposta = await new Colaborador().updateColaborador(
            this.id,
            this.colaborador
          );
          this.dialog.show = false;
          this.$emit("saved");
        } catch (error) {
          this.$alert.setAlert(true, "error", error);
        }
      }
    }
  }
};
</script>

<style></style>
